"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animations = void 0;
exports.animations = {
    fadeIn: 'ft-fadeIn',
    slideUp: 'ft-slideUp',
    wave: 'ft-wave',
    elastic: 'ft-elastic',
    bounceIn: 'ft-bounceIn',
    rotateIn: 'ft-rotateIn',
    colorTransition: 'ft-colorTransition',
    fadeAndScale: 'ft-fadeAndScale',
    slideInFromLeft: 'ft-slideInFromLeft',
    blurIn: 'ft-blurIn',
    typewriter: 'ft-typewriter',
    highlight: 'ft-highlight',
    blurAndSharpen: 'ft-blurAndSharpen',
    dropIn: 'ft-dropIn'
};
